import axios from 'axios';

// 쇼핑몰 카테고리 트리 (/api/products/categories)
// Header·LeftSidebar 가 함께 쓰므로 한 번만 요청하고 결과(Promise)를 공유한다.
// 페이지 이동 중에는 재사용하고, 새로고침하면 다시 받는다. 실패하면 다음 호출에서 재시도.
let categoriesPromise = null;

export function getShopCategories() {
  if (!categoriesPromise) {
    categoriesPromise = axios.get('/api/products/categories')
      .then(response => response.data)
      .catch(error => {
        categoriesPromise = null;
        throw error;
      });
  }
  return categoriesPromise;
}
